export default "__VITE_PUBLIC_ASSET__15052c96__"